import React from "react";
import styled from "styled-components";
import Img from "gatsby-image"

const TrailingIcon = ({img, bigTopPadding}) => {
  const Icon = styled.img`
    margin: 0 0 50px;
    max-width: 80%;
    padding-top: ${bigTopPadding ? '70px' : null}
  `;
  return (
    <Icon
      src={img.resolutions.src || img}
      alt="Icon for the end of the section"
    />
  );
};

export const trailingIcon = graphql`
  fragment TrailingIcon on ImageSharp {
    resolutions(width: 350) {
      src
    }
  }
`;

export default TrailingIcon;



// WEBPACK FOOTER //
// ./src/components/TrailingIcon/index.js